import PropTypes from 'prop-types';

const propTypeStyleBody = PropTypes.shape({
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  backgroundPosition: PropTypes.string,
  backgroundSize: PropTypes.string,
});

export default propTypeStyleBody;
